import React from "react"
import Controls from "./Controls/Controls"
import { Box } from "@mui/material"

export function CommonWrapper(props: any) {
  return (
    <Box sx={{ padding: 2 }}>
      <Controls />
      {props.children}
    </Box>
  )
}
